import debounce from 'lodash/debounce'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import classNames from 'classnames'

import { actions, selectors } from 'modules/links'
import { isSitemapParsed } from 'modules/queues/selectors'

class QueueFilter extends Component {
  static propTypes = {
    filter: PropTypes.string,
    isSitemapParsed: PropTypes.bool.isRequired,
    updateQueueFilter: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.filterInput.value = this.props.filter
    this.delayedCallback = debounce(this.props.updateQueueFilter, 300)
  }

  shouldComponentUpdate(nextProps) {
    return this.props.isSitemapParsed !== nextProps.isSitemapParsed
  }

  filterData() {
    this.delayedCallback && this.delayedCallback(this.filterInput.value)
  }

  render() {
    const classes = classNames('queue-filter pb-4', { 'hidden': !this.props.isSitemapParsed })
    return (
      <div className={ classes }>
        <i className="zmdi zmdi-search" />
        <input
          type="text"
          className="form-control"
          ref={c => this.filterInput = c}
          onChange={::this.filterData}
          placeholder="What page are you looking for?"
        />
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  isSitemapParsed,
  filter: selectors.getQueueFilter
})

export default connect(mapStateToProps, Object.assign({}, actions))(QueueFilter)



// WEBPACK FOOTER //
// ./src/components/links/links-filter.js